import Glider from './glider.js'


var planPlusSelected=[];
window.cotationSlider;
var cotationController = function () {
    
    var additionalEvent = function() {

        
        $('select[name=additional_id').on('change',function(){
            let _this = this;
            let additional_id = $(_this).val();
            let plan_id = $(_this).closest('.td_plan_id').data('plan_id');

            $(".coverage_plus[data-plan_id=" + plan_id + "] .coverage_show").hide();
            $(".coverage_plus[data-plan_id=" + plan_id + "] .coverage_hide").show();

            if(additional_id!=0){
                for(let i=0; i<coveragesPlus[additional_id].coverages.length; i++){
                    let classPath = ".coverage_plus[data-plan_id=" + plan_id + "][data-coverage_id=" + coveragesPlus[additional_id].coverages[i].id + "]";

                    $(classPath + " .coverage_show[data-additional_id=" + additional_id + "]").show();
                    $(classPath + " .coverage_show[data-additional_id=" + additional_id + "]").html(
                        coveragesPlus[additional_id].currency + ' ' + coveragesPlus[additional_id].coverages[i].is
                    );


                    $(classPath + " .coverage_hide").hide();
                    $(".coverage_row[data-coverage_id=" + coveragesPlus[additional_id].coverages[i].id + "]").show();
                }
            }else{
                $(".coverage_plus[data-plan_id=" + plan_id + "] .coverage_show").hide();
                $(".coverage_plus[data-plan_id=" + plan_id + "] .coverage_hide").show();
            }

            
            
            for(let i=0; i<planListJson.length; i++){
                if(planListJson[i].plan_id==plan_id && planListJson[i].additional_id==additional_id){
                    $(".td_plan_id[data-plan_id=" + plan_id + "] .price-table").html(planListJson[i].priceArray[0])
                    $(".td_plan_id[data-plan_id=" + plan_id + "] .price-cents-table").html(planListJson[i].priceArray[1])
                    $(".td_plan_id[data-plan_id=" + plan_id + "] .targetjuros span").html(planListJson[i].parcel)
                  
                }
            }

            
            

        });

    }

    var cotationSliderMobile = function() {
        if($('.cotationSlider')[0]){
            window.cotationSlider = new Glider(document.querySelector('.cotationSlider'), {
                // Mobile-first defaults
                slidesToShow: 1,
                slidesToScroll: 1,
                scrollLock: true,
                scrollLockDelay:100,
                duration:1,
                draggable: true,
                eventPropagate:false,
                dots: '.dots',
                arrows: {
                    prev: '.glider-prev',
                    next: '.glider-next'
                },
            });
        }
       
    } 
    return {
        init: function() {
            additionalEvent();
            cotationSliderMobile();
        }
    };
}();
    
$(function () {
    cotationController.init();
});
